import ProfileIcon from '#assets/icon/navigation/ProfileIcon';
import WriteIcon from '#assets/svg/write_icon.svg';
import Bookmarked from '#assets/svg/bookmarked.svg';
import { axios } from '#api/axios';
import { useToast } from '#providers/ToastProvider';
import SaveIcon from 'src/r_page/community/Icon/SaveIcon';
import { isUser } from 'src/refactor_shared/util/isUser';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useUserInfo } from '#providers/UserInfo';

interface Props {
  isBookmarked: boolean;
  isWritable: 'write' | 'block' | 'edit';
  content?: string;
  sequence?: number;
}

const QnaThreadNavigation = ({
  isBookmarked,
  isWritable,
  content,
  sequence
}: Props) => {
  const naivgate = useNavigate();
  const { id } = useParams();
  const { showToast } = useToast();
  const { userInfo } = useUserInfo();
  const queryClient = useQueryClient();
  const { mutate: postBookmarkQuestion } = useMutation({
    mutationFn: async () =>
      await axios.post('/consumer/qna/bookmarks', { questionId: id }),
    onSuccess: () => {
      queryClient.invalidateQueries(['get-trainer-community-save']);
      showToast({
        message: '관심글로 지정하였습니다.'
      });
      queryClient.invalidateQueries({
        queryKey: ['get-trainer-community-save']
      });
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '일시적인 에러입니다. 다시 시도해 주세요.'
      });
    }
  });

  return (
    <>
      {userInfo ? (
        <div className="flex flex-col gap-16 w-full bg-[#1F1E25] rounded-t-8 py-16 px-20 fixed bottom-0 left-1/2 -translate-x-1/2 border-t-1 max-w-939 border-solid border-[#2E2B36]">
          <>
            <p className="text-center text-[14px]">
              {userInfo?.status === 'ACCEPT'
                ? '답변을 통해 당신의 지식을 나타내 보세요.'
                : '프로필 공개 상태에서만 답변을 작성할 수 있어요.'}
            </p>
            <div className="flex items-center justify-between gap-16">
              <button
                type="button"
                className={`text-[14px] ${
                  isBookmarked ? 'text-[#9170F2]' : 'text-[#8E899F]'
                } w-full flex items-center justify-center gap-4 text-center py-12 rounded-12 bg-[#2E2B36]`}
                onClick={() => {
                  if (isUser()) {
                    postBookmarkQuestion();
                  } else {
                    naivgate('/sign');
                  }
                }}
              >
                {isBookmarked ? <img src={Bookmarked} alt="" /> : <SaveIcon />}
                관심글
              </button>
              <UserStatusNavigation
                sequence={sequence}
                content={content}
                to={id}
                isWritable={isWritable}
                userStatus={userInfo?.status}
              />
            </div>
          </>
        </div>
      ) : (
        <UnLoginQnaThreadNavigation />
      )}
    </>
  );
};

const UserStatusNavigation = ({
  userStatus,
  to,
  isWritable,
  content,
  sequence
}: {
  userStatus?: string;
  to?: string;
  isWritable: 'write' | 'block' | 'edit';
  content?: string;
  sequence?: number;
}) => {
  const navigate = useNavigate();
  return userStatus === 'TAKEN' ? (
    <Link
      to={'/profile'}
      className="flex justify-center items-center text-[14px] gap-4 w-full text-center py-12 rounded-12 bg-[#7750E9] text-[#EAE8ED]"
    >
      <ProfileIcon isSelect={'#EAE8ED'} width="16" height="14" />
      프로필로 이동
    </Link>
  ) : (
    <>
      {isWritable === 'write' ? (
        <Link
          to={isUser() ? `/community/qna/answer/${to}` : '/sign'}
          className="flex justify-center items-center gap-4 w-full text-center py-12 rounded-12 bg-[#7750E9] text-[#EAE8ED]"
        >
          <img src={WriteIcon} className="w-16 h-14" />
          답변하기
        </Link>
      ) : isWritable === 'block' ? (
        <button
          onClick={() =>
            navigate(`/community/qna/answer/${to}`, {
              state: { content, sequence }
            })
          }
          className="flex justify-center items-center gap-4 w-full text-center py-12 rounded-12 bg-[#7750E9] text-[#EAE8ED]"
        >
          <img src={WriteIcon} className="w-16 h-14" />
          수정하기
        </button>
      ) : null}
    </>
  );
};

export default QnaThreadNavigation;

const UnLoginQnaThreadNavigation = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-16 w-full bg-[#1F1E25] rounded-t-8 py-16 px-20 fixed bottom-0 left-1/2 -translate-x-1/2 border-t-1 max-w-939 border-solid border-[#2E2B36]">
      <>
        <p className="text-center text-[14px]">
          답변을 통해 당신의 지식을 나타내 보세요.
        </p>
        <div className="flex items-center justify-between gap-16">
          <button
            type="button"
            className={`text-[14px] text-[#8E899F] w-full flex items-center justify-center gap-4 text-center py-12 rounded-12 bg-[#2E2B36]`}
            onClick={() => navigate('/sign')}
          >
            <SaveIcon />
            관심글
          </button>
          <Link
            to={'/sign'}
            className="flex justify-center items-center gap-4 w-full text-center py-12 rounded-12 bg-[#7750E9] text-[#EAE8ED]"
          >
            <img src={WriteIcon} className="w-16 h-14" />
            답변하기
          </Link>
        </div>
      </>
    </div>
  );
};
